import {
  getLatestPublishedReadingOrders,
  getPopularReadingOrders,
  getTrendingReadingOrders,
} from "../../../services/readingOrdersApi";

/**
 * The discovery rows shown at the top of Browse. Each one maps to a public
 * API list of (at most) 25 reading orders.
 *
 * Mirrors the mobile app's features/discover/helpers/discoverSections.js.
 */
export const DISCOVER_SECTIONS = [
  {
    key: "popular",
    title: "Popular reading orders",
    eyebrow: "POPULAR READING ORDERS",
    description: "The reading orders people are reading right now.",
    fetch: getPopularReadingOrders,
  },
  {
    key: "trending",
    title: "Trending up",
    eyebrow: "TRENDING UP",
    description:
      "The reading orders readers have started reading in the last couple of weeks.",
    fetch: getTrendingReadingOrders,
  },
  {
    key: "latest",
    title: "Latest reading orders",
    eyebrow: "LATEST READING ORDERS",
    description: "The most recent reading orders published by Redwing.",
    fetch: getLatestPublishedReadingOrders,
  },
];

export const getDiscoverSection = (key) =>
  DISCOVER_SECTIONS.find((section) => section.key === key) ?? null;

export const discoverQueryKey = (key) => ["discover", key];

export const discoverQueryOptions = { staleTime: 5 * 60 * 1000 };

/**
 * Normalise a discovery API payload ({data: [...]}) into a list of orders.
 */
export const getDiscoverItems = (payload) =>
  Array.isArray(payload?.data)
    ? payload.data.filter((item) => item && typeof item === "object")
    : [];

/**
 * "2000-2011 • 223 comics • 54 readers" (years are optional)
 */
export const formatReadingOrderMeta = (readingOrder) => {
  if (!readingOrder) {
    return "";
  }

  const comicsCount = Number(readingOrder.comicsCount) || 0;
  const readersCount =
    Number(readingOrder.readersCount ?? readingOrder.readingCount) || 0;

  return [
    readingOrder.years,
    `${comicsCount} ${comicsCount === 1 ? "comic" : "comics"}`,
    `${readersCount} ${readersCount === 1 ? "reader" : "readers"}`,
  ]
    .filter(Boolean)
    .join(" • ");
};
